import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { getFormValues, reduxForm, change } from 'redux-form/immutable';
import { connect } from 'react-redux';

// actions
import { currentManagerUpdate } from '../../../actions/currentManagerActions';
import { initialize } from 'redux-form';

// components
import HolidayForm from '../_HolidayForm';
import ScheduleForm from '../_ScheduleForm';
import {
  Button,
  Error,
  PhoneNumberInput,
  StateSelect,
} from '../../shared/_form';
import { SimplePanel } from '../../shared/_panel';
import { Field, FormSection } from 'redux-form/immutable';
import AppointmentsLimit from '../../shared/managers/_AppointmentsLimit';
import MassEmailMessage from './MassEmailMessage';

// constants
const FORM_NAME = 'managerEdit';

class Edit extends React.Component {
  static propTypes = {
    currentUser: PropTypes.instanceOf(Immutable.Map),
    formValues: PropTypes.instanceOf(Immutable.Map),
  };

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  componentDidMount() {
    this._initForm(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this._initForm(nextProps);
  }

  render() {
    const { currentUser, formValues, changeFormData } = this.props;

    if (!currentUser || !Immutable.Map.isMap(currentUser)) {
      return null;
    }

    const errorData = currentUser.get('error');
    const errors = Immutable.Map.isMap(errorData)
      ? errorData
      : Immutable.Map(errorData || {});
    const loading = currentUser.get('loading');

    // Ensure formValues is always an Immutable.Map
    const safeFormValues = Immutable.Map.isMap(formValues)
      ? formValues
      : Immutable.Map(formValues || {});

    return (
      <div className="manager-edit">
        {safeFormValues && (
          <SimplePanel className="manager-edit__panel" header="Settings">
            <form onSubmit={this._handleSubmit}>
              <div className="manager-edit__section">
                <h2 className="manager-edit__section__header">
                  User Information
                </h2>
                <Field
                  className="form__field form__field--rounded"
                  component="input"
                  name="name"
                  type="text"
                />
                <Error className="form__error--rounded">
                  {errors.get('name')}
                </Error>
                <Field
                  className="form__field form__field--rounded"
                  component="input"
                  name="email"
                  type="email"
                />
                <Error className="form__error--rounded">
                  {errors.get('user.email')}
                </Error>
                <Field
                  className="form__field form__field--rounded"
                  component="input"
                  name="password"
                  placeholder="Password"
                  type="password"
                />
                <Error className="form__error--rounded">
                  {errors.get('user.password')}
                </Error>
              </div>
              <div className="manager-edit__section">
                <h2 className="manager-edit__section__header">
                  Office Information
                </h2>
                <div className="form__group">
                  <Field
                    className="form__field form__field--rounded"
                    component="input"
                    name="office.name"
                    type="text"
                  />
                  <Error className="form__error--rounded">
                    {errors.get('office.name')}
                  </Error>
                </div>
                <div className="form__group">
                  <Field
                    className="form__field form__field--rounded"
                    component="input"
                    name="office.address"
                    type="text"
                  />
                  <Error className="form__error--rounded">
                    {errors.get('office.address')}
                  </Error>
                </div>
                <div className="form__group">
                  <div className="manager__form__office__city">
                    <Field
                      className="form__field form__field--rounded"
                      component="input"
                      name="office.city"
                      type="text"
                    />
                    <Error className="form__error--rounded">
                      {errors.get('office.city')}
                    </Error>
                  </div>
                  <div className="manager__form__office__state">
                    <Field
                      className="form__select"
                      component={this._renderStateSelect}
                      name="office.state"
                      placeholder="State"
                    />
                    <Error>{errors.get('office.state')}</Error>
                  </div>
                  <div className="manager__form__office__postal-code">
                    <Field
                      className="form__field form__field--rounded"
                      component="input"
                      name="office.postalCode"
                      type="text"
                    />
                    <Error className="form__error--rounded">
                      {errors.get('office.postalCode')}
                    </Error>
                  </div>
                </div>
                <div className="form__group">
                  <Field
                    className="form__field form__field--rounded"
                    component={this._renderPhoneNumberInput}
                    name="office.phoneNumber"
                    type="text"
                  />
                  <Error className="form__error--rounded">
                    {errors.get('office.phoneNumber')}
                  </Error>
                </div>
              </div>
              <div className="manager-edit__section">
                <h2 className="manager-edit__section__header">
                  Appointments are available
                </h2>
                <FormSection name="office.schedule">
                  <ScheduleForm form={FORM_NAME} formValues={safeFormValues} />
                </FormSection>
              </div>
              <div className="manager-edit__section">
                <h2 className="manager-edit__section__header">
                  Office is closed on
                </h2>
                <HolidayForm form={FORM_NAME} formValues={safeFormValues} />
              </div>
              <div className="manager-edit__section">
                <h2 className="manager-edit__section__header">
                  Appointments limit
                </h2>
                <AppointmentsLimit
                  changeFormData={changeFormData}
                  formValues={safeFormValues}
                  name={'office'}
                />
              </div>
              <div className="manager-edit__section manager-edit__section">
                <h2 className="manager-edit__section__header">
                  Scheduling guidelines and restrictions
                </h2>
                <div className="form__group">
                  <Field
                    className="form__field form__field--rounded"
                    component="input"
                    name="office.guidelines"
                    type="text"
                  />
                  <Error className="form__error--rounded">
                    {errors.get('office.guidelines')}
                  </Error>
                </div>
              </div>

              <div className="manager-edit__section manager-edit__section">
                <h2 className="manager-edit__section__header">
                  Send emails to your premium followers
                </h2>
                <div className="form__group">
                  <MassEmailMessage />
                </div>
              </div>

              <div
                className="manager-edit__section manager-edit__section--last"
                id={'opening-info'}
              >
                <h2 className="manager-edit__section__header">Opening info</h2>
                <small>
                  eg: "first Tuesday of the month before the quarter starts,
                  morning"
                </small>
                <div className="form__group">
                  <Field
                    className="form__field form__field--textarea"
                    component="textarea"
                    name="office.openingInfo"
                    type="text"
                  />
                  <Error className="form__error--rounded">
                    {errors.get('office.openingInfo')}
                  </Error>
                </div>
              </div>
              <div className="form__submit">
                <Button
                  className="form__button form__button--green"
                  loading={loading}
                >
                  Save
                </Button>
              </div>
            </form>
          </SimplePanel>
        )}
      </div>
    );
  }

  // private

  _handleSubmit = this._handleSubmit.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const { dispatch, formValues } = this.props;

    // Ensure formValues is always an Immutable.Map before using it
    const safeFormValues = Immutable.Map.isMap(formValues)
      ? formValues
      : Immutable.Map(formValues || {});

    // Pass safe formValues to validate functions
    ScheduleForm.validate({ ...this.props, formValues: safeFormValues });
    HolidayForm.validate({ ...this.props, formValues: safeFormValues });

    dispatch(currentManagerUpdate(safeFormValues.toJS()));
  }

  _initForm(props) {
    let currentUser = props.currentUser.get('data');

    if (currentUser) {
      const office = currentUser.get('office');
      const phoneNumber = office.get('phoneNumber');

      currentUser = currentUser.set(
        'office',
        office.set('phoneNumber', phoneNumber.replace(/^\+1/, '')),
      );
    }

    if (!this.state.data.get('formInitialized') && currentUser) {
      props.dispatch(initialize(FORM_NAME, currentUser, { keepDirty: true }));

      this.setState({ data: this.state.data.set('formInitialized', true) });
    }
  }

  _renderPhoneNumberInput({ input, meta, ...rest }) {
    const value = input.value ? input.value.replace(/^\+1/, '') : '';

    return <PhoneNumberInput {...input} {...rest} value={value} />;
  }

  _renderStateSelect({ input, meta, ...rest }) {
    const value =
      input.value && input.value.length > 0 ? input.value : 'placeholder';

    return <StateSelect {...input} {...rest} value={value} />;
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    formValues: getFormValues(FORM_NAME)(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFormData: (state, value) => dispatch(change(FORM_NAME, state, value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(reduxForm({ form: FORM_NAME })(Edit));



// WEBPACK FOOTER //
// ./app/components/managers/profile/Edit.jsx